import React from 'react';
import { useContactForm } from '../hooks/useContactForm';
import ContactInfo from './ContactInfo';
import ContactForm from './ContactForm';

const ContactSection = () => {
  const { formData, loading, isRobot, setIsRobot, handleChange, handleSubmit } = useContactForm();

  return (
    <section id="contact" className="bg-[#2C2C2A] text-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold mb-6 tracking-tight">
            Contact US
          </h2>
          <p className="text-xl text-[#E4E1D8] max-w-2xl mx-auto">
            Ready to start your journey? Get in touch with our team today
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Contact Info */}
          <ContactInfo />

          {/* Contact Form */}
          <ContactForm 
            formData={formData}
            loading={loading}
            isRobot={isRobot}
            setIsRobot={setIsRobot}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
          />
        </div>
      </div>
    </section>
  );
};

export default ContactSection;